// assets/header.js
class Header {
  constructor() {
    this.header = document.querySelector('[data-header]');
    this.headerNav = document.querySelector('[data-header-nav]');
    this.menuToggle = document.querySelector('[data-menu-toggle]');
    this.lastScrollPosition = window.pageYOffset;
    this.headerHeight = this.header.offsetHeight;
    
    this.init();
  }

  init() {
    this.bindEvents();
    this.handleScroll = this.handleScroll.bind(this);
    window.addEventListener('scroll', this.handleScroll);
  }

  bindEvents() {
    if (this.menuToggle) {
      this.menuToggle.addEventListener('click', () => {
        this.headerNav.classList.toggle('is-active');
        this.menuToggle.setAttribute(
          'aria-expanded',
          this.menuToggle.getAttribute('aria-expanded') === 'false' ? 'true' : 'false'
        );
      });
    }
  }

  handleScroll() {
    const currentScrollPosition = window.pageYOffset;
    
    if (currentScrollPosition > this.headerHeight) {
      if (currentScrollPosition > this.lastScrollPosition) {
        // Scrolling down
        this.headerNav.classList.add('is-hidden');
      } else {
        // Scrolling up
        this.headerNav.classList.remove('is-hidden');
      }
    }
    
    this.lastScrollPosition = currentScrollPosition;
  }
}

// Initialize header
document.addEventListener('DOMContentLoaded', () => {
  new Header();
});